/**
 * from: "\/tr\/press\/su-sakip-sabanci-muzesinde-yeni-sergi-mack-sadece-isik-ve-renk-18-subatta-aciliyor"
 * to: "su-sakip-sabanci-muzesinde-yeni-sergi-mack-sadece-isik-ve-renk-18-subatta-aciliyor"
 */
export const getSlugOfPressRelease = (slug: string) => {
  const splittedSlug = slug.split('tr/')
  return splittedSlug[1] || ''
}
